<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div id="pageItemList">
    <v-layout row class="align-center layout px-4 pt-4 app--page-header">
      <div class="page-header-left">
        <h3 class="pr-3">
          <v-icon>build</v-icon>
          {{ $t("serviceReport") }} #{{ serviceReport.rma }}
        </h3>
      </div>
      <v-breadcrumbs divider="-" :items="breadcrumbs"> </v-breadcrumbs>
    </v-layout>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex md6 lg4>
          <v-card>
            <v-toolbar card>
              <v-toolbar-title>{{ $t("vehicle") }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-icon color="primary">train</v-icon>
            </v-toolbar>

            <v-list two-line>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ serviceReport.vehicle.name }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("vehicle") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ serviceReport.vehicle_part }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("vehiclePart") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ $t("projectPhases." + serviceReport.project_phase) }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("projectPhase") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ serviceReport.odometer }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("odometer") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{
                      $t("occurrencePlaces." + serviceReport.occurrence_place)
                    }}
                    <span v-if="serviceReport.occurrence_place === 'OTHER'">
                      ({{ serviceReport.occurrence_place_custom }})
                    </span>
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("occurrencePlace") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-divider></v-divider>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    <span v-if="serviceReport.vehicle_excluded_from">
                      {{ $t("from") }}
                      {{
                        $moment(serviceReport.vehicle_excluded_from).format(
                          "LLL"
                        )
                      }}
                      {{ $t("until") }}
                      {{
                        $moment(serviceReport.vehicle_excluded_until).format(
                          "LLL"
                        )
                      }}
                    </span>
                    <span v-else>
                      {{ $t("no") }}
                    </span>
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("vehicleExcluded") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>

        <v-flex md6 lg4>
          <v-card>
            <v-toolbar card>
              <v-toolbar-title>{{ $t("issue") }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-icon color="primary">bug_report</v-icon>
            </v-toolbar>

            <v-list two-line>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    <span v-if="serviceReport.issue">
                      #{{ serviceReport.issue.rma }}
                    </span>
                    <span v-else>
                      {{ $t("lack") }}
                    </span>
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("assignedIssue") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action v-if="serviceReport.issue">
                  <v-btn
                    icon
                    ripple
                    :to="{
                      name: 'IssueShow',
                      params: { id: serviceReport.issue.id }
                    }"
                  >
                    <v-icon color="primary">details</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>

              <v-divider></v-divider>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{
                      $t(
                        "issueAppearMethods." +
                          serviceReport.issue_appear_method
                      )
                    }}
                    <span v-if="serviceReport.issue_appear_method_complaint_number">
                      ({{ serviceReport.issue_appear_method_complaint_number }})
                    </span>
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("issueAppearMethod") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ $t("issueCategories." + serviceReport.issue_category) }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("issueCategory") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action
                  v-if="
                    serviceReport.issue_category === VEHICLE_OUT_OF_ORDER ||
                      serviceReport.issue_category === VEHICLE_CANT_WORK
                  "
                >
                  <v-icon color="red">warning</v-icon>
                </v-list-tile-action>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ serviceReport.issue_description | lackOfData }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("issueDescription") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ serviceReport.displayed_message | lackOfData }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("serviceReportDisplayedMessage") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ serviceReport.has_diagnostic_report | booleanText }}
                    <span v-if="serviceReport.has_diagnostic_report">
                      ({{ serviceReport.diagnostic_report_info }})
                    </span>
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("hasDiagnosticReport") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>

        <v-flex md6 lg4>
          <v-card>
            <v-toolbar card>
              <v-toolbar-title>{{ $t("repair") }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-icon color="primary">build</v-icon>
            </v-toolbar>

            <v-list two-line>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{
                      $t("repairCategories." + serviceReport.repair_category)
                    }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("repairCategory") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{
                      serviceReport.additional_repair_outside_vehicle
                        | booleanText
                    }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("additionalRepairOutsideVehicle") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-divider></v-divider>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    ({{ serviceReport.repair_code.code }})
                    {{ serviceReport.repair_code.name }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("repairCode") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    ({{ serviceReport.reason.code }})
                    {{ serviceReport.reason.name }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("reason") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>

        <v-flex md6>
          <v-card>
            <v-toolbar card>
              <v-toolbar-title>{{ $t("issueCode") }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-icon color="primary">bug_report</v-icon>
            </v-toolbar>

            <v-list>
              <v-list-tile
                v-for="(issueCode, key) in serviceReport.issue_code"
                :key="key"
              >
                <v-list-tile-content>
                  <v-list-tile-title>
                    ({{ issueCode.code }}) {{ issueCode.name }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>

        <v-flex md6>
          <v-card>
            <v-toolbar card>
              <v-toolbar-title>{{ $t("component") }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-icon color="primary">extension</v-icon>
            </v-toolbar>

            <v-list two-line>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ serviceReport.product_group.name }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("productGroups") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ serviceReport.component.name }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("component") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>

        <v-flex md6>
          <v-card>
            <v-toolbar card>
              <v-toolbar-title>{{ $t("sparePart") }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-icon color="primary">memory</v-icon>
            </v-toolbar>

            <v-list two-line v-if="serviceReport.replaced_spare_part">
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ serviceReport.replaced_spare_part.serial_number }} ({{
                      serviceReport.replaced_spare_part.type.name
                    }})
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("replacedSparePart") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{
                      serviceReport.replaced_spare_part.replaced_on
                        .serial_number
                    }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("sparePartReplacedOn") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <v-list v-else>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ $t("lack") }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>

        <v-flex md6>
          <v-card>
            <v-toolbar card>
              <v-toolbar-title>{{
                $t("additionalInformation")
              }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-icon color="primary">extension</v-icon>
            </v-toolbar>

            <v-list two-line>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ serviceReport.additional_information | lackOfData }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("additionalInformation") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{
                      serviceReport.has_affect_passenger_safety | booleanText
                    }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("hasAffectPassengerSafety") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import { FETCH_SERVICE_REPORT } from "@/store/actions.type";
import {
  VEHICLE_CANT_WORK,
  VEHICLE_OUT_OF_ORDER
} from "@/common/enums/issueCategories";

export default {
  data() {
    return {
      VEHICLE_OUT_OF_ORDER: VEHICLE_OUT_OF_ORDER,
      VEHICLE_CANT_WORK: VEHICLE_CANT_WORK,
      breadcrumbs: [
        {
          text: this.$t("serviceReports"),
          to: { name: "ServiceReports" },
          exact: true
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["serviceReport", "serviceReportIsLoading"])
  },
  methods: {},
  beforeRouteEnter(to, from, next) {
    Promise.all([store.dispatch(FETCH_SERVICE_REPORT, to.params.id)]).then(
      () => {
        next();
      }
    );
  }
};
</script>

<style scoped></style>
